var m = require('mithril');

var LOCATION_CLASSES = [
  'Site',
  'Building',
  'Floor',
  'Level',
  'Room',
];

function isLocationClass(className) {
  return LOCATION_CLASSES.includes(className);
}

function buildUsedOnPathHref(path) {
  if (!path || !path['@class'] || !path['@rid']) return null;

  var className = path['@class'].toLowerCase();
  var rid = path['@rid'].slice(1);

  if (isLocationClass(path['@class'])) {
    return `/location/${rid}`;
  }

  return `/${className}/${rid}`;
}

function buildEquipmentPathHref(path) {
  if (!path || !path['@class'] || !path['@rid']) return null;

  var className = path['@class'].toLowerCase();
  var rid = path['@rid'].slice(1);
  return `/equipment/${className}/${rid}`;
}

module.exports = {
  oninit: function(vnode) {
    var ctrl = this;
    ctrl.parentCtrl = vnode.attrs.parentCtrl;
    ctrl.classesWithDirectLinks = ['Dashboard'].concat(LOCATION_CLASSES);
    ctrl.classesWithNoLinks = [
      'Element',
      'Dataset',
      'Point',
      'Column'
    ]
  },

  view: function(vnode) {
    var ctrl = this;
    return m('div', [
      ctrl.parentCtrl.point().usedOn && Array.isArray(ctrl.parentCtrl.point().usedOn) && ctrl.parentCtrl.point().usedOn.length > 0 ?
        [
          m('div.bb.bw1.pr3', [
            m("p.mb1", "Used on:"),
          ]),
          m('table.db', { class: 'table w-100 mt2 mb3' }, [
            m('thead', [
              m('tr', [ 
                m('th.tl', 'Path:'),
              ])
            ]),
             m('tbody.db.w-100', [
              ctrl.parentCtrl.point().usedOn.map(record => {
                return m('tr.db.w-100', [
                  m('td.db.w-100', 
                    m('div.flex.flex-wrap.items-center', [
                      record.map((path, index) => {
                        if (!path || !path['@class'] || !path['@rid']) return null;
                    
                        const isHome = path.name === 'root';
                        const label = isHome ? 'Home' : path.name ? `${path.name} (${path['@class']})` : `${path['@class']}`;
                        const isLast = index === record.length - 1;
                        const isNoLink = ctrl.classesWithNoLinks.includes(path['@class']);
                        const hasUrl = !!path.url;
                    
                        let linkEl;
                        if (ctrl.classesWithDirectLinks.includes(path['@class'])) {
                          linkEl = m(m.route.Link, {
                            href: buildUsedOnPathHref(path),
                            class: 'link dim blue'
                          }, label);
                        } else if (isNoLink) {
                          if (hasUrl) {
                            linkEl = m('a', { href: path.url, class: 'link dim blue' }, label);
                          } else {
                            linkEl = label;
                          }
                        } else {
                          linkEl = m(m.route.Link, {
                            href: buildEquipmentPathHref(path),
                            class: 'link dim blue'
                          }, label);
                        }
                    
                        const postfix = isLast ? null : (
                          isNoLink ? ' - ' : ' / '
                        );
                    
                        return m('span.mr1.nowrap.truncate', [
                          linkEl,
                          postfix && m('span', postfix)
                        ]);
                      })
                    ])

                  )
                ]);
              })
            ])
          ])
        ]
      : '',

    ]);
  }
}

module.exports.__testables = {
  buildEquipmentPathHref: buildEquipmentPathHref,
  buildUsedOnPathHref: buildUsedOnPathHref,
  isLocationClass: isLocationClass
};
